import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadMedia } from "../lib/api";

const field = { background: "#f5f7f6", border: "1px solid #e5e7eb" };

// Upload de photo réutilisable (partenaire + Founder). Choisit un fichier, l'envoie
// à /api/media/upload et renvoie l'URL publique via onChange.
export const ImageUpload = ({ value, onChange, testid = "image-upload" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("Image trop lourde (max 5 Mo)"); return; }
    setBusy(true);
    try {
      const { url } = await uploadMedia(file);
      onChange(url);
      toast.success("Photo ajoutée");
    } catch { toast.error("Échec de l'upload de la photo"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      {value ? (
        <div className="relative w-14 h-14 rounded-xl overflow-hidden flex-shrink-0" style={field}>
          <img src={value} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`}
            className="absolute top-0 right-0 w-5 h-5 flex items-center justify-center text-white" style={{ background: "rgba(0,0,0,.5)" }}>
            <X size={12} />
          </button>
        </div>
      ) : null}
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testid}-btn`}
        className="flex items-center gap-2 rounded-xl px-3 h-11 text-sm font-semibold" style={field}>
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
        {busy ? "Envoi…" : (value ? "Changer la photo" : "Choisir une photo")}
      </button>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
    </div>
  );
};
